import { render, staticRenderFns } from "./ModalHistoryStatus.vue?vue&type=template&id=f376bc80"
import script from "./ModalHistoryStatus.vue?vue&type=script&lang=js"
export * from "./ModalHistoryStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports